import React, {ChangeEvent} from "react";
import {ShopCard} from "./ShopCard";
import {Shop} from "@/entities/shop";
import {Svg} from "@/shared/ui/Svg";
import {Input} from "@/shared/ui/Input";
import {useDebounceFn} from "@/shared/lib/hooks/useDebounceFn";
import styles from "./ShopSidebar.module.scss";
import {Spinner} from "@/shared/ui/Spinner";

type Props = {
    shops: Shop[];
    onShowOnMap: (shop: Shop) => void;
    query: string;
    loading: boolean;
    setQuery: (query: string) => void;
    fetchShops: () => void;
}

export const ShopSidebar = ({shops, onShowOnMap, query, loading, setQuery, fetchShops}: Props) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);

        debouncedSearch();
    };
    const handleSubmit = () => {
        fetchShops();
    };

    const debouncedSearch = useDebounceFn(() => {
        fetchShops();
    }, 500);

    return (
        <div className={styles.sidebarContainer}>
            <Spinner show={loading} />
            <div className={styles.searchContainer}>
                <button
                    type={`button`}
                    className={styles.searchSubmitButton}
                    onClick={handleSubmit}
                >
                    <Svg id={`search`} className={styles.searchSubmitIcon} />
                </button>
                <Input
                    name={`shopSearch`}
                    value={query}
                    placeholder={`Название магазина, адрес или метро`}
                    className={styles.searchInput}
                    onChange={handleChange}
                />
            </div>
            {query !== '' && shops.length === 0 && (
                <p className={styles.nothingWasFound}>Ничего не найдено</p>
            )}
            {shops.length > 0 && (
                <div className={styles.listContainer}>
                    {shops.map(shop => (
                        <ShopCard key={shop.id} shop={shop} onShowOnMap={onShowOnMap} />
                    ))}
                </div>
            )}
        </div>
    );
}
